export default "__VITE_ASSET__C9w985vv__"